import _ from 'lodash';
import EnrollmentStateConfig from './config/RouteConfig';
import EnrollmentService from './services/EnrollmentService';
import 'plugin?auth-type!gw-portals-auth-angular/module';
import SignupEnrollment from './components/SignupEnrollment';
import AdditionalEnrollment from './components/AdditionalEnrollment';
import 'gw-portals-viewmodel-angular/aspects/module';
import 'edge/platform/widgets/basicinputs/module';

const STATE_REJECTION = 6;

export default angular.module('edge.enrollment.app', [
    'portal.config',
    'ui.router',
    'edge.platform.base',
    'gw-portals-viewmodel-angular.aspects',
    'edge.platform.widgets.basicinputs'
])
    .config(['$stateProvider', 'state_plugin_config', ($stateProvider, RootStateConfig) => {
        const states = new EnrollmentStateConfig(RootStateConfig);
        _.values(states).forEach((state) => {
            $stateProvider.state(state);
        });
    }])

    .config(['EventHubProvider', EventHubProvider => {
        EventHubProvider.registerTransformer({
            source: {
                category: 'tracking',
                eventName: 'serverCall'
            },
            target: {
                category: 'journey',
                eventName: 'account'
            },
            transformer(payload, send) {
                if (payload && payload.success && payload.method === 'addEnrollmentRecord') {
                    send({
                        accountNumber: payload.params[0].accountNumber,
                        policyNumber: payload.params[0].details.policyNumber,
                        method: payload.method,
                        path: payload.path
                    });
                }
            }
        });
    }])

    .factory('enrollment.EnrollmentService', EnrollmentService)
    .component('gwSignupEnrollment', SignupEnrollment)
    .component('gwAdditionalEnrollment', AdditionalEnrollment)

    .run(['$state', ($state) => {
        const errorHandler = $state.defaultErrorHandler();
        $state.defaultErrorHandler((error) => {
            // This is a replacement for $rootScope.$on('$stateChangeError'
            if (error.type === STATE_REJECTION && error.detail.goToEnrollmentPage) {
                $state.go(error.detail.goToEnrollmentPage);
            } else {
                errorHandler(error);
            }
        });
    }]);
